var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.807 5.14 1.526-1.533V10a.667.667 0 1 0 1.334 0V3.607l1.526 1.533a.666.666 0 0 0 .947 0 .667.667 0 0 0 0-.947L8.473 1.527a.667.667 0 0 0-.22-.14.667.667 0 0 0-.506 0 .667.667 0 0 0-.22.14L4.86 4.193a.67.67 0 1 0 .947.947ZM14 9.333a.667.667 0 0 0-.667.667v2.667a.667.667 0 0 1-.666.666H3.333a.667.667 0 0 1-.666-.666V10a.667.667 0 0 0-1.334 0v2.667a2 2 0 0 0 2 2h9.334a2 2 0 0 0 2-2V10A.666.666 0 0 0 14 9.333Z",
    fill: "#999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.566b11a3e98e64df70e9460efcc342ae.svg";
export { ForwardRef as ReactComponent };